import { useSelector } from "react-redux";
import ConfirmationDialog from "../../Dialogs/ConfirmationDialog";
import { RootState } from "../../..";

const DeleteFolderDialog = ({
  open,
  handleCancel,
  deleteFolder,
}: {
  open: boolean;
  handleCancel: () => void;
  deleteFolder: () => void;
}) => {
    const selectedRow = useSelector((state: RootState) => state.examOverview.selectedRow);
    const itemName = selectedRow?.name;

  return (
    
    <ConfirmationDialog
      isOpen={open}
      handleCancel={() => handleCancel()}
      handleConfirm={() => deleteFolder()}
      title={`Ordner ${itemName} löschen?`}
      text={`Möchten Sie den Ordner und alles darin wirklich unwiderruflich löschen?`}
      cancelTitle="Abbrechen"
      confirmTitle="Löschen"
    />
  );
};

export default DeleteFolderDialog;
